module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1008-a48f34ea221b28875b141d9db9a043ab.png";